module.exports = __webpack_public_path__ + "static/media/payroll.8247e994.png";